import { render, staticRenderFns } from "./TransactionReview.vue?vue&type=template&id=74f024e6&scoped=true"
import script from "./TransactionReview.vue?vue&type=script&lang=js"
export * from "./TransactionReview.vue?vue&type=script&lang=js"
import style0 from "./TransactionReview.vue?vue&type=style&index=0&id=74f024e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f024e6",
  null
  
)

export default component.exports